const IDR = new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  maximumFractionDigits: 0,
})

export function formatIdr(value: string | bigint): string {
  const amount = typeof value === 'bigint' ? value : safeBigInt(value)
  return IDR.format(amount)
}

export function safeBigInt(value: string): bigint {
  if (!/^-?\d+$/.test(value)) throw new Error('Nilai rupiah tidak valid')
  return BigInt(value)
}

export function addMoney(...values: string[]): string {
  return values.reduce((sum, value) => sum + safeBigInt(value), 0n).toString()
}

export function subtractMoney(left: string, right: string): string {
  return (safeBigInt(left) - safeBigInt(right)).toString()
}

export function sanitizeMoneyInput(value: string): string {
  const digits = value.replace(/[^\d]/g, '')
  return digits.replace(/^0+(?=\d)/, '')
}

export function formatMoneyInput(value: string): string {
  const digits = sanitizeMoneyInput(value)
  if (!digits) return ''
  return new Intl.NumberFormat('id-ID', { maximumFractionDigits: 0 }).format(BigInt(digits))
}
